import type { HelpCenterPanelProps } from "./help-center-panel.type";

import { Typography } from "antd";
import { useTranslation } from "react-i18next";

import HelpCenterButton from "../help-center-button";
import HelpCenterIcon from "../help-center-icon";

import "./help-center-panel.style.less";

const { Text } = Typography;

const HelpCenterPanel = ({ hideIcon }: HelpCenterPanelProps) => {
  const { t } = useTranslation();

  return (
    <div className="help-center-panel">
      {!hideIcon && <HelpCenterIcon />}
      <Text>{t("global:helpCenter.tagline")}</Text>
      <HelpCenterButton />
    </div>
  );
};

export default HelpCenterPanel;
